import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

// YOUR Firebase configuration (Get from Firebase Console)
const firebaseConfig = {
  apiKey: "AIzaSyAsewp1yXO5OOlvvB4r5cqmsCNSKxun1PI",
  authDomain: "pm-dream-manors.firebaseapp.com",
  projectId: "pm-dream-manors",
  storageBucket: "pm-dream-manors.firebasestorage.app",
  messagingSenderId: "125141618962",
  appId: "1:125141618962:web:70003e109c3a6e285463cb",
  measurementId: "G-HEZ2BK7FR9"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
